import React from "react";

export default function Shards() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="275"
      height="207"
      fill="none"
      preserveAspectRatio="xMidYMax meet"
      viewBox="0 0 275 207"
    >
      <path
        fill="#4086EA"
        d="M197 40l10 33 11-33h-21zM97 186l43-21-26 26-17-5zM0 7l77 66L14 0 0 7zm256 200l-21-64 40 64h-19z"
      ></path>
    </svg>
  );
}
